import React, { createContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [selectedSite, setSelectedSite] = useState("");
  const [selectedSiteName, setSelectedSiteName] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loading, setLoading] = useState(true);

  // Load saved user and site info on first render
  useEffect(() => {
    const savedUser = localStorage.getItem("user");
    const token = localStorage.getItem("token");
    const savedSite = localStorage.getItem("selectedSite");
    const savedSiteName = localStorage.getItem("selectedSiteName");
    const savedFromDate = localStorage.getItem("fromDate");
    const savedToDate = localStorage.getItem("toDate");

    if (savedUser && token) {
      try {
        const parsedUser = JSON.parse(savedUser);
        setUser(parsedUser);
      } catch (error) {
        console.error("Error parsing user data:", error);
        localStorage.removeItem("user");
        localStorage.removeItem("token");
      }
    }

    if (savedSite) setSelectedSite(savedSite);
    if (savedSiteName) setSelectedSiteName(savedSiteName);
    if (savedFromDate) setFromDate(savedFromDate);
    if (savedToDate) setToDate(savedToDate);

    setLoading(false);
  }, []);

  // Save fromDate and toDate to localStorage whenever they change
  useEffect(() => {
    localStorage.setItem("fromDate", fromDate);
  }, [fromDate]);

  useEffect(() => {
    localStorage.setItem("toDate", toDate);
  }, [toDate]);

  const login = (token, userData) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(userData));
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('selectedSite');
    localStorage.removeItem('selectedSiteName');
    localStorage.removeItem('fromDate');
    localStorage.removeItem('toDate');
    setUser(null);
    setSelectedSite("");
    setSelectedSiteName("");
    setFromDate("");
    setToDate("");
  };

  return (
    <AuthContext.Provider 
      value={{ 
        user, 
        selectedSite, 
        setSelectedSite, 
        selectedSiteName, 
        setSelectedSiteName, 
        fromDate,
        setFromDate,
        toDate,
        setToDate,
        login, 
        logout,
        loading 
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;